import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$getOwnPropertyNames from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-names";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _ from 'lodash';
import { sha256 } from 'js-sha256';
import { log } from '@jutro/logger';
import ImplDescriptor from './ImplDescriptor';
let Contract = function () {
  function Contract(specification, ...extended) {
    _classCallCheck(this, Contract);
    this.spec = _.merge(..._mapInstanceProperty(extended).call(extended, c => c.spec), specification);
    this.hashFunc = _.memoize(() => {
      var _context;
      const keyTar = _sortInstanceProperty(_context = _Object$keys(this.spec)).call(_context).join('');
      return sha256(keyTar);
    });
  }
  _createClass(Contract, [{
    key: "implementedBy",
    value: function implementedBy(implementor) {
      var _context2;
      const descriptor = new ImplDescriptor(implementor);
      let adheres = true;
      const members = descriptor.getMembers();
      _forEachInstanceProperty(_context2 = _Object$getOwnPropertyNames(this.spec)).call(_context2, specKey => {
        const member = descriptor.getMember(specKey);
        if (!member || typeof member !== this.spec[specKey]) {
          log.warning(!_includesInstanceProperty(members).call(members, specKey) ? `Missing member: ${specKey}` : `Invalid type for ${specKey}: '${typeof member}' is not of type '${this.spec[specKey]}'`);
          adheres = false;
        }
      });
      return adheres;
    }
  }, {
    key: "hash",
    value: function hash() {
      return this.hashFunc();
    }
  }, {
    key: "toString",
    value: function toString() {
      return `contract {${_Object$keys(this.spec).join(',')}}`;
    }
  }], [{
    key: "specify",
    value: function specify(specification) {
      return new Contract(specification);
    }
  }]);
  return Contract;
}();
export { Contract as default };